const telephone = (value) => {
  const regexPhoneNumber = new RegExp(
    /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/,
  ).test(value);
  const regexRepeatedNumbers = new RegExp(
    /0{5,}|1{5,}|2{5,}|3{5,}|4{5,}|5{5,}|6{5,}|7{5,}|8{5,}|9{5,}/,
  ).test(value);
  return value ? regexPhoneNumber && !regexRepeatedNumbers : true;
};

export default telephone;
